import React, { useState } from 'react';
import ChangeOfOwnership from '../ChangeOfOwnership/ChangeOfOwnership';
import QueryContractForm from '../../../Components/Stepper/Steps/QueryContract/QueryContractForm';
import { ROUTE_NAMES } from '../../../Routes/Routes';
import { useEffect } from 'react';
import { history } from '../../../Routes/history';
import { useContext } from 'react';
import {
  UserContext,
  UserDispatchContext
} from '../../../Contexts/UserContext';
import { logoutUser } from '../../../Utils/User/Actions';
import _get from 'lodash/get';
import {
  ContractsContext,
  ContractSelectedContext,
  ContractSetSelected
} from '../../../Contexts/ContractsContext';
import { AlertsDispatchContext } from '../../../Contexts/AlertsContext';
import { useCallback } from 'react';
import {
  extractErrorMessage,
  redirectOnAuthFailure
} from '../../../Utils/Errors/Errors';
import { PutSelectContract } from '../../../API/Contracts/ContractsAPI';

const TARGET_FORM = 'ChangeOwnershipCampaignForm';

const ChangeOfOwnershipWrapperGDC = ({ match }) => {
  const currentUser = useContext(UserContext);
  const authToken = _get(currentUser, 'token');
  const setCurrentUser = useContext(UserDispatchContext);
  const contracts = useContext(ContractsContext);
  const setAlert = useContext(AlertsDispatchContext);
  const selectedContract = useContext(ContractSelectedContext);
  const setSelectedContract = useContext(ContractSetSelected);

  const [validatedContract, setValidatedContract] = useState(
    Boolean(currentUser)
  );
  const [selectedContractInfo, setSelectedContractInfo] = useState(null);

  const contractIdFromParams = match && match.params && match.params.contractId;

  const onSelectContract = useCallback(
    async contract => {
      setSelectedContract(contract);
      const response = await PutSelectContract(currentUser.token, contract.id);
      if (response.success) {
        // no success message, its all good
      } else {
        if (
          redirectOnAuthFailure(response, '/', () => logoutUser(setCurrentUser))
        ) {
          return;
        }
        setAlert({
          type: 'error',
          message: extractErrorMessage(response).message
        });
      }
    },
    [setSelectedContract, currentUser, setCurrentUser, setAlert]
  );

  useEffect(() => {
    if (contractIdFromParams && !contractIdFromParams.match(/^[0-9]+$/)) {
      history.replace(ROUTE_NAMES.home);
      return;
    }

    if (authToken && contractIdFromParams && contracts) {
      const contractFromParams = contracts.find(
        contract => contract.id === parseInt(contractIdFromParams, 10)
      );

      if (!contractFromParams) {
        history.replace(ROUTE_NAMES.home);
        return;
      }

      onSelectContract(contractFromParams);
      setSelectedContractInfo(contractFromParams);
      setValidatedContract(true);
      return;
    }

    if (authToken && !selectedContract) {
      history.replace(ROUTE_NAMES.contracts);
      return;
    }

    if (authToken && selectedContract) {
      setSelectedContractInfo(selectedContract);
      setValidatedContract(true);
      return;
    }
  }, [
    authToken,
    contractIdFromParams,
    contracts,
    onSelectContract,
    selectedContract,
    selectedContractInfo
  ]);

  const goBack = () => {
    setValidatedContract(false);
  };

  return (
    <>
      {!validatedContract && (
        <QueryContractForm
          selectedContractInfo={selectedContractInfo}
          setSelectedContractInfo={setSelectedContractInfo}
          setValidatedContract={setValidatedContract}
          targetForm={TARGET_FORM}
          queryTitle="Cambio de titular"
          queryReason="cambio de titular"
          defaultValue={contractIdFromParams}
        />
      )}

      {validatedContract && (
        <ChangeOfOwnership
          contract={selectedContractInfo}
          goBack={authToken ? undefined : goBack}
        />
      )}
    </>
  );
};

export default ChangeOfOwnershipWrapperGDC;
